module.exports = __webpack_public_path__ + "static/media/cookie-mob-background.fb9a1366.svg";